import React, { Component } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { ToastContainer } from "react-toastify";
import registerFaIcons from "./services/registerFaIcons";

import theme from "../infrastructure/theme/index";

import authClient from "./auth/Auth";
import { findCompanyDetail } from "../infrastructure/repository/company-repository";
import { addContextLog } from "../infrastructure/log";
import Routes from "./routes/Routes";

import "../assets/main.scss";
import "loaders.css";
import ContextsProvider from "../infrastructure/Contexts";
import ModalProvider from "./components/modals/ModalProvider";
import CobeeLoader from "./components/CobeeLoader";
import analytics from "./segment";

registerFaIcons();

class App extends Component<any, { loadPage: string }> {
  constructor(props) {
    super(props);
    this.state = {
      loadPage: "wait",
    };
  }

  async componentDidMount() {
    if (authClient.isAuthenticated()) {
      const { data } = await findCompanyDetail();
      addContextLog("info", "User is authenticated", "authentication", {
        companyId: data.id,
      });
      localStorage.setItem("company_name", data.companyName);
      localStorage.setItem("pricing_type", data.pricingType);

      analytics.identify(authClient.getEmployeeId(), {
        companyID: authClient.getCompanyId(),
        companyName: authClient.getCompanyName(),
      });

      addContextLog("info", "Go to home", "authentication");
      this.setState({ loadPage: "navigation" });
    } else {
      addContextLog("info", "User no authenticated", "authentication");
    }
  }

  render() {
    const { loadPage } = this.state;
    return (
      <div>
        {loadPage === "wait" && <CobeeLoader />}
        {loadPage === "navigation" && (
          <ThemeProvider theme={theme}>
            <ContextsProvider>
              <ToastContainer
                position="bottom-right"
                closeOnClick
                pauseOnHover
              />
              <ModalProvider />
              <Routes />
            </ContextsProvider>
          </ThemeProvider>
        )}
      </div>
    );
  }
}

export default App;
